import React, { useCallback } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Typography } from '@vivaahealth/design-system';

import styles from './rte-error-page.module.css';

import { RteErrorAlert } from './components';
import { RteState } from '../types';

import * as api from '../../../../../api';
import RteErrorReviewDataCard from './components/RteErrorReviewDataCard';

interface RteErrorReviewPageProps extends WithTranslation {
  rteState: RteState;
  setRteState: React.Dispatch<React.SetStateAction<RteState>>;
  cards: api.PatientInsuranceInformation.InsuranceInformationWithDetails[];
  patientInsuranceInformationId: string;
  payorsDisplayNameMapping: Record<string, string>;
  onCancel: () => Promise<void>;
  onAddInsurance: () => void;
}

const RteErrorReviewPage = ({
  rteState,
  setRteState,
  cards,
  patientInsuranceInformationId,
  payorsDisplayNameMapping,
  onCancel,
  onAddInsurance,
  t,
}: RteErrorReviewPageProps) => {
  const getExtraContent = useCallback(() => {
    switch (rteState.error) {
      case api.PatientRealTimeEligibility.EligibilityResponse.Inactive:
        return {
          children: (
            <RteErrorReviewDataCard
              cards={cards}
              payorsDisplayNameMapping={payorsDisplayNameMapping}
              onAddInsurance={onAddInsurance}
              onCancel={onCancel}
              patientInsuranceInformationId={patientInsuranceInformationId}
              setRteState={setRteState}
            />
          ),
          title: t('rteCannotAddCardHeader'),
        };
      default:
        return { children: null, title: '' };
    }
  }, [
    cards,
    onAddInsurance,
    onCancel,
    patientInsuranceInformationId,
    payorsDisplayNameMapping,
    rteState,
    setRteState,
    t,
  ]);

  const { children, title } = getExtraContent();

  return (
    <div className={styles.container}>
      <Typography variant="headline-small" bold>
        {title}
      </Typography>
      <RteErrorAlert rteError={rteState.error} />
      {children}
    </div>
  );
};

export default withTranslation(['rteErrorReviewPage', 'insurance'])(
  RteErrorReviewPage,
);
